// PDP variant image filter: only show images matching the selected color.
// Horizon renders two galleries per product (mobile slideshow + desktop grid); we filter both.
(function () {
  function norm(s) {
    if (!s) return null;
    return String(s).toLowerCase().replace(/[\s_]+/g, '-').replace(/[^a-z0-9-]/g, '');
  }

  function colorInputs() {
    return document.querySelectorAll(
      'input[type="radio"][name*="Color" i], input[type="radio"][name*="Colour" i]'
    );
  }

  function selectedColor() {
    for (const r of colorInputs()) if (r.checked) return norm(r.value);
    const sel = document.querySelector('select[name*="Color" i], select[name*="Colour" i]');
    if (sel && sel.value) return norm(sel.value);
    return null;
  }

  // Use the product's own option values as the token list. Longest first so
  // "indigo-blue" wins over "blue" and "indigo".
  function knownColorTokens() {
    const set = new Set();
    for (const r of colorInputs()) if (r.value) set.add(norm(r.value));
    const sel = document.querySelector('select[name*="Color" i], select[name*="Colour" i]');
    if (sel) Array.from(sel.options || []).forEach((o) => o.value && set.add(norm(o.value)));
    return Array.from(set).filter(Boolean).sort((a, b) => b.length - a.length);
  }

  function detectColor(text, tokens) {
    if (!text) return null;
    const low = String(text).toLowerCase().replace(/[\s_]+/g, '-');
    for (const t of tokens) {
      const re = new RegExp('(^|-)' + t + '(-|$|\\.)');
      if (re.test(low)) return t;
    }
    return null;
  }

  function imgFor(el) {
    return el ? el.querySelector('img') : null;
  }

  function textForNode(el) {
    const img = imgFor(el);
    if (!img) return '';
    const src = img.src || img.getAttribute('data-src') || '';
    const fname = src.split('/').pop().split('?')[0];
    return fname + ' ' + (img.alt || '');
  }

  function applyToNodes(nodes, chosen, tokens) {
    if (!nodes.length) return;
    const decisions = Array.from(nodes).map((el) => {
      const color = detectColor(textForNode(el), tokens);
      return { el, color, hide: !!color && color !== chosen };
    });
    // Safety: never hide everything.
    if (!decisions.some((d) => !d.hide)) decisions.forEach((d) => (d.hide = false));
    decisions.forEach((d) => {
      if (d.hide) {
        d.el.setAttribute('hidden', '');
        d.el.setAttribute('data-sr-hidden', '');
        d.el.style.display = 'none';
      } else if (d.el.hasAttribute('data-sr-hidden')) {
        d.el.removeAttribute('hidden');
        d.el.removeAttribute('data-sr-hidden');
        d.el.style.display = '';
      }
    });
    return decisions;
  }

  function apply() {
    const chosen = selectedColor();
    if (!chosen) return;
    const tokens = knownColorTokens();
    if (!tokens.length) return;

    document.querySelectorAll('media-gallery, product-media-gallery').forEach((gallery) => {
      // Desktop grid cells
      const gridCells = gallery.querySelectorAll('.media-gallery__grid .product-media-container');
      applyToNodes(gridCells, chosen, tokens);

      // Mobile carousel slides
      const slides = gallery.querySelectorAll('slideshow-component slideshow-slide');
      const slideDecisions = applyToNodes(slides, chosen, tokens);

      // If the currently-active slide got hidden, advance the slideshow.
      const slideshow = gallery.querySelector('slideshow-component');
      if (slideshow && slideDecisions && typeof slideshow.select === 'function') {
        const currentIsHidden = slideDecisions.length > 0 && slideDecisions[0].hide;
        if (currentIsHidden) {
          const firstVisible = slideDecisions.findIndex((d) => !d.hide);
          if (firstVisible >= 0) {
            try { slideshow.select(firstVisible, undefined, { animate: false }); } catch (e) {}
          }
        }
      }

      // Sync thumbnail / dot controls by parallel index.
      const thumbGroups = gallery.querySelectorAll('[ref="thumbnails"], [ref="dots"]');
      thumbGroups.forEach((group) => {
        Array.from(group.children).forEach((btn, i) => {
          const d = slideDecisions && slideDecisions[i];
          if (!d) return;
          if (d.hide) {
            btn.setAttribute('hidden', '');
            btn.setAttribute('data-sr-hidden', '');
            btn.style.display = 'none';
          } else if (btn.hasAttribute('data-sr-hidden')) {
            btn.removeAttribute('hidden');
            btn.removeAttribute('data-sr-hidden');
            btn.style.display = '';
          }
        });
      });
    });
  }

  function schedule() { setTimeout(apply, 40); }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('variant:update', schedule);
  document.addEventListener('variant:selected', schedule);
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.matches) return;
    if (t.matches(
      'input[type="radio"][name*="Color" i], input[type="radio"][name*="Colour" i], ' +
      'select[name*="Color" i], select[name*="Colour" i]'
    )) schedule();
  });
})();
